import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift, Sparkles } from 'lucide-react';
const bonuses = [{
  id: 1,
  title: 'The Body Back in 30 Reset Menu',
  image: 'https://cdn.magicpatterns.com/uploads/gj3HysKSw4wcCqLVvZKhfJ/bono1.png',
  description: 'When you finally get a window… the last thing you need is decision fatigue. This is a clean, pick-one menu of 12 simple options to use your 30 minutes on purpose—so you step back into the day lighter.',
  includes: ["12 'pick-1' reset options (shower, food, downshift, sunlight, stretch, etc.)", 'The simple 5–20–5 structure (land → reset → close)', "'Only got 10 minutes?' mini version", '1-minute Before/After check-in']
}, {
  id: 2,
  title: "The 'Someone Else's Arms' Handoff Guide",
  image: 'https://cdn.magicpatterns.com/uploads/htb81b6jSf8DQ4YtE2tBq8/bono2.png',
  description: "Support shouldn't require a 10-minute explanation… every time. This is the calm, one-sheet handoff system you can give to a grandparent, sitter, or friend—so you can step away for 30–60 minutes without spiraling.",
  includes: ['3 simple handoff sheets (different situations)', "'Before you leave the room' checklist", 'Ready-to-send texts to set expectations gently', 'Printable + phone-friendly version']
}, {
  id: 3,
  title: "The 'I Need Help' Text Script Kit",
  image: 'https://cdn.magicpatterns.com/uploads/gs7bBNjs5HcyXxCHdEFney/bono3.png',
  description: "Sometimes the hardest part isn't the nap. It's asking for help—without guilt, without over-explaining, without feeling like you have to justify it. This kit gives you 18 copy-paste messages you can send in 30 seconds.",
  includes: ['18 scripts (partner, grandparents, friend, sitter)', 'Simple message formula: time + task + duration + kind close', "Follow-ups that don't feel awkward", "'My non-negotiables' template (so your help actually helps)"]
}];
export function Bonuses() {
  return <section className="py-16 md:py-24 px-6 md:px-8 bg-cream-dark relative overflow-hidden" data-id="element-2">
      {/* Subtle ambient glow */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-terracotta/5 rounded-full blur-3xl pointer-events-none" data-id="element-3" />

      <div className="max-w-4xl mx-auto relative" data-id="element-4">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="text-center mb-16 md:mb-24" data-id="element-5">
          {/* Premium badge */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="inline-flex items-center gap-2 bg-terracotta/10 border border-terracotta/20 rounded-full px-5 py-2 mb-6" data-id="element-6">
            <Gift className="w-4 h-4 text-terracotta" data-id="element-7" />
            <p className="text-xs uppercase tracking-[0.2em] text-terracotta font-bold" data-id="element-8">
              3 Exclusive Bonuses — Free Today
            </p>
            <Sparkles className="w-3.5 h-3.5 text-terracotta/70" data-id="element-9" />
          </motion.div>

          <h2 className="font-serif text-3xl md:text-5xl text-brown mb-6 leading-tight" data-id="element-10">
            You're not just getting the Reset.
          </h2>
          <p className="text-lg md:text-xl text-brown-light max-w-2xl mx-auto leading-relaxed mb-4" data-id="element-11">
            You're getting the tools that make the 30 minutes{' '}
            <span className="italic" data-id="element-12">actually happen</span>—and feel good when
            they do.
          </p>
          <div className="inline-flex items-center gap-3 bg-terracotta/8 border border-terracotta/15 rounded-full px-5 py-2.5 mt-1" data-id="element-13">
            <span className="text-sm text-brown-light/50 line-through" data-id="element-14">
              $47 value
            </span>
            <span className="text-terracotta font-bold text-sm tracking-wide" data-id="element-15">
              Yours FREE today
            </span>
          </div>
        </motion.div>

        {/* Bonus Cards */}
        <div className="space-y-12 md:space-y-20 mb-20" data-id="element-16">
          {bonuses.map((bonus, index) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.7,
          delay: index * 0.1,
          ease: 'easeOut'
        }} className="relative bg-white rounded-3xl p-6 md:p-10 shadow-[0_8px_40px_rgba(61,50,41,0.08)] border border-brown/5 flex flex-col md:flex-row gap-8 md:gap-12 items-center" data-id="element-17">
              {/* Top accent line */}
              <div className="absolute top-0 left-8 right-8 h-px bg-gradient-to-r from-transparent via-terracotta/30 to-transparent" data-id="element-18" />

              {/* Image */}
              <div className="w-full md:w-2/5 shrink-0 relative" data-id="element-19">
                <div className="relative aspect-square rounded-2xl overflow-hidden shadow-lg border border-brown/5 bg-cream" data-id="element-20">
                  <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-21" />
                  <div className="absolute inset-0 bg-gradient-to-tr from-brown/5 to-transparent pointer-events-none" data-id="element-22" />
                </div>
                {/* FREE badge on image */}
                <div className="absolute -top-3 -right-3 md:-top-4 md:-right-4 bg-terracotta text-white text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-full shadow-lg" data-id="element-23">
                  Free
                </div>
              </div>

              {/* Content */}
              <div className="w-full md:w-3/5" data-id="element-24">
                <div className="mb-4" data-id="element-25">
                  <div className="flex items-center gap-3 mb-2" data-id="element-26">
                    <p className="text-sm font-bold tracking-widest text-sage uppercase" data-id="element-27">
                      Bonus #{bonus.id}
                    </p>
                    <div className="h-px flex-1 bg-sage/15" data-id="element-28" />
                  </div>
                  <h3 className="font-serif text-2xl md:text-3xl text-brown mb-3" data-id="element-29">
                    {bonus.title}
                  </h3>
                </div>

                <p className="text-brown-light leading-relaxed mb-6" data-id="element-30">
                  {bonus.description}
                </p>

                <div className="space-y-3" data-id="element-31">
                  <p className="text-sm font-semibold text-brown uppercase tracking-wider mb-4" data-id="element-32">
                    What's included:
                  </p>
                  {bonus.includes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-33">
                      <div className="mt-0.5 w-5 h-5 rounded-full bg-sage/10 flex items-center justify-center shrink-0" data-id="element-34">
                        <Check className="w-3 h-3 text-sage-dark" data-id="element-35" />
                      </div>
                      <span className="text-brown-light text-sm md:text-base leading-snug" data-id="element-36">
                        {item}
                      </span>
                    </div>)}
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Bottom Summary */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="relative max-w-3xl mx-auto" data-id="element-37">
          {/* Summary card with elevated styling */}
          <div className="rounded-3xl p-8 md:p-12 border border-brown/10 shadow-[0_12px_48px_rgba(61,50,41,0.1)]" style={{
          background: 'linear-gradient(160deg, #FFFFFF 0%, #FAF7F2 100%)'
        }} data-id="element-38">
            <div className="flex items-center justify-center gap-2 mb-2" data-id="element-39">
              <Sparkles className="w-4 h-4 text-terracotta" data-id="element-40" />
              <p className="text-xs uppercase tracking-[0.2em] text-terracotta font-bold" data-id="element-41">
                Your Complete Bonus Stack
              </p>
              <Sparkles className="w-4 h-4 text-terracotta" data-id="element-42" />
            </div>
            <h3 className="font-serif text-2xl md:text-3xl text-brown text-center mb-8" data-id="element-43">
              3 premium tools. All yours.{' '}
              <span className="text-terracotta italic" data-id="element-44">Free.</span>
            </h3>

            <div className="space-y-4 mb-8" data-id="element-45">
              {bonuses.map(bonus => <div key={bonus.id} className="flex items-center gap-4 py-3 px-4 rounded-xl bg-cream/80 border border-brown/5" data-id="element-46">
                  <div className="w-12 h-12 rounded-xl overflow-hidden shrink-0 shadow-sm border border-brown/5" data-id="element-47">
                    <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-48" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-49">
                    <span className="text-brown font-medium text-sm md:text-base block truncate" data-id="element-50">
                      {bonus.title}
                    </span>
                  </div>
                  <div className="shrink-0 bg-sage/10 text-sage-dark text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full" data-id="element-51">
                    Free
                  </div>
                </div>)}
            </div>

            <div className="pt-6 border-t border-brown/10" data-id="element-52">
              <div className="flex flex-col items-center gap-3" data-id="element-53">
                <div className="flex items-center gap-3" data-id="element-54">
                  <span className="text-brown-light/50 text-lg line-through decoration-terracotta/40" data-id="element-55">
                    $47
                  </span>
                  <span className="font-serif text-3xl md:text-4xl text-terracotta font-bold" data-id="element-56">
                    $0
                  </span>
                </div>
                <p className="text-brown-light text-sm" data-id="element-57">
                  Included free with your purchase today
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}